import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=6649dc10&scoped=true"
var script = {}
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=6649dc10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649dc10",
  null
  
)

export default component.exports